import { action, observable } from 'mobx'
import { validationContext } from 'validx'
import { ConfigEditorViewModelBase } from './ConfigEditorViewModelBase'
import type { StalenessConfig } from './legend-options'

/**
 * When requests go stale, which notifies their collaborators.
 */
export class StalenessConfigEditorViewModel extends ConfigEditorViewModelBase<StalenessConfig> {
  @observable accessor enabled = false
  @observable accessor recurring = false

  /**
   * Seconds.
   */
  @observable accessor staleAfter = 0

  readonly validation = validationContext(this, {})

  /**
   * Turns staleness on or off.
   */
  @action.bound
  setEnabled(value: boolean) {
    this.enabled = value
  }

  /**
   * Whether collaborators are notified until the request is active again.
   */
  @action.bound
  setRecurring(value: boolean) {
    this.recurring = value
  }

  /**
   * Sets the inactivity, in seconds, after which requests go stale.
   */
  @action.bound
  setStaleAfter(value: number) {
    this.staleAfter = value
  }

  /** @inheritDoc */
  @action
  hydrate(config: StalenessConfig | undefined) {
    this.enabled = config?.enabled ?? false
    this.staleAfter = config?.staleAfter ?? 0
    this.recurring = config?.recurring ?? false
  }

  /** @inheritDoc */
  toJSON(): StalenessConfig {
    return {
      enabled: this.enabled,
      recurring: this.recurring,
      staleAfter: this.staleAfter,
    }
  }
}
